import React, { useState } from "react";
import useTable from "../../../../components/useTable";
import { InfoButton } from "../../../../ui/buttons/Button";
import { Textarea } from "../../../../ui/inputs/Input";
const headCells = [
  {
    id: "descripcion",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Descripción",
    textAlign: "center",
  },
  {
    id: "tipoPag",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Tipo Pag.",
    textAlign: "center",
  },
  {
    id: "nomArchivo",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nom. Archivo",
    textAlign: "center",
  },
];

export default function TablaFormatoReporte(){
  const [tableData, setTableData] = useState([]);
    const [filterFn, setFilterFn] = useState({
      fn: (items) => {
        return items;
      },
    });
  
    const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
      tableData,
      headCells,
      filterFn
    );
  return <div className="col-12 m-0 p-0 d-flex flex-wrap">
    <div className="col-11 m-0 p-0">
      <TblContainer>
        <TblHead />
        <tbody>
          {tableData &&
            recordsAfterPagingAndSorting().map((item, index) => (
              <tr key={index}></tr>
            ))}
        </tbody>
      </TblContainer>
    </div>
    <div className="col-1 m-0 p-0 d-flex gap-2 alingn-items-center justify-content-center">
      <div className="col-auto m-0 p-0">
        <InfoButton icon = 'fa-print m-0' />
      </div>
    </div>
    <div className="col-12 m-0 mt-2 p-0">
      <Textarea label = 'Descripción:' style = {{ height: 70 }} />
    </div>
  </div>
}